//For big itins this should be turned off even in dev mode
export const DEVTOOLS_ENABLED = false;

/** Sentinel `selectedOrg.name` for a guest (public itinerary) session. */
export const GUEST_ORG_NAME = "__guest__";

/** The public pricing page. The only place a browser can change plan. */
export const CHOOSE_PLAN_URL = "https://eventr.softpauer.com/choose-plan/";
